import { throwError } from "@/lib/throwError";
import { mergeServiceDeskBody, mergeServiceDeskParams } from "@/lib/serviceDeskApiParams";
import { get, post, put } from "@/services/axiosUitils";
import {
  SchemaPayload,
  TenantSchema,
  TenantSchemaList,
} from "@/utils/types/schemas";

const basePath = "/formily/schemas";

/** Spaces / special chars in schema names must be encoded (e.g. "ServiceDesk Enduser"). */
function schemaNameSeg(schemaName: string): string {
  if (!schemaName?.trim()) {
    throwError("Schema name is required", "SchemaService");
  }
  return encodeURIComponent(schemaName.trim());
}

class SchemaService {
  getAllSchemas = async ({
    page,
    pageSize,
    search,
  }: {
    page: number;
    pageSize: number;
    search: string;
  }): Promise<TenantSchemaList> => {
    return await get<TenantSchemaList>(`${basePath}/`, {
      params: mergeServiceDeskParams({
        page,
        page_size: pageSize,
        search,
      }),
    });
  };

  getSchemaByName = async (schemaName: string): Promise<TenantSchema> => {
    return await get<TenantSchema>(`${basePath}/${schemaNameSeg(schemaName)}/`, {
      params: mergeServiceDeskParams({}),
    });
  };

  createSchema = async ({
    schemaName,
    payload,
  }: SchemaPayload): Promise<any> => {
    if (!schemaName || !payload) {
      throwError("Schema name and payload are required", "SchemaService");
    }
    return await post(`${basePath}/${schemaNameSeg(schemaName)}/`, mergeServiceDeskBody(payload));
  };

  updateSchema = async ({
    schemaName,
    payload,
  }: SchemaPayload): Promise<any> => {
    if (!schemaName || !payload) {
      throwError("Schema name and payload are required", "SchemaService");
    }
    return await put(`${basePath}/${schemaNameSeg(schemaName)}/`, mergeServiceDeskBody(payload));
  };

  getDropDownData = async (schemaName: string): Promise<any> => {
    if (!schemaName) {
      throwError("Schema name is required", "SchemaService");
    }
    return await get(`${basePath}/${schemaNameSeg(schemaName)}/drop_down_data/`, {
      params: mergeServiceDeskParams({}),
    });
  };

  getColumnGridData = async (schemaName: string): Promise<any> => {
    if (!schemaName) {
      throwError("Schema name is required", "SchemaService");
    }
    return await get(`${basePath}/${schemaNameSeg(schemaName)}/column-grid/`, {
      params: mergeServiceDeskParams({}),
    });
  };
}

const instance = new SchemaService();
export default instance;
